import type { AggregatedPaper } from "@types";

export function countByTopic(papers: AggregatedPaper[]): Map<string, number> {
  const counter = new Map<string, number>();
  for (const paper of papers) {
    const current = counter.get(paper.topic) ?? 0;
    counter.set(paper.topic, current + 1);
  }
  return counter;
}
